import { AnalyticsBrowser } from '@segment/analytics-next'

declare global {
  interface Window {
    segment: AnalyticsBrowser | null;
  }
}

export function initSegment () {
  const writeKey = document.head.querySelector<HTMLMetaElement>('meta[name="segment:write-key"]')?.content

  if (!writeKey) {
    return
  }

  // TODO: Instead of assigning the AnalyticsBrowser instance to `window.segment`, we should instead export the instance
  // from this file and import it where needed.

  window.segment = AnalyticsBrowser.load(
    {
      writeKey,
      cdnURL: 'https://sgmt-cdn.thatch.ai',
    },
    {
      integrations: {
        'Segment.io': {
          apiHost: 'sgmt-api.thatch.ai/v1',
          protocol: 'https',
        },
      },
    }
  )
}
